import type { AssetInfoPlanFileProps } from "./asset-info-plan-file.type";

import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useAppNotification } from "@/modules/app-notification";
import { downloadFileWithNotify } from "@/modules/file-downloader";
import { FlexContainerJsx } from "@/modules/flex-container";
import { PdfViewer } from "@/ui/pdf-viewer";

export const AssetInfoPlanFile = ({ planFile }: AssetInfoPlanFileProps) => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();

  const [page, setPage] = useState(1);

  if (!planFile) return null;

  return (
    <FlexContainerJsx
      fullWidth={true}
      value={
        <>
          <Button
            type="text"
            aria-label="download"
            style={{ width: "100%" }}
            onClick={() => {
              const { url, name } = planFile;
              downloadFileWithNotify({ url, name, notify });
            }}
          >
            {planFile.name}
            <DownloadOutlined />
          </Button>
          <PdfViewer
            initialPage={page}
            toolbarOptions={{
              showPagination: true,
              showZoom: false,
              showGoToHighlightPage: false,
            }}
            source={planFile.url}
            onPageChange={setPage}
          />
        </>
      }
      label={t("asset:form.plan.label")}
    />
  );
};
